import React, {Component} from "react";

/**
 * @param children - Needs valid react components
 * @param padContent - bool
 */
class Content extends Component {

   render() {
      const { padContent = true, children } = this.props;
      return (
         <section id="content" className={`animated fadeIn ${padContent ? '' : 'pn'}`}>
            {children}
         </section>
      );
   }
}

export default Content;